import { Button } from '@material-ui/core'
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom'

export const BotonAuditar = ({detalleSolicitud, ...props}) => {
    
    const { idUsuario } = useSelector((state) => state.auth);
    const [redirect, setRedirect] = useState(false);
  
    const handleClick = (e) => {
        e.preventDefault();
        setRedirect(true);
    }
   
    return (
        <>
            <Button
                variant="contained" 
                color="primary"
                onClick={handleClick}
                disabled={
                    detalleSolicitud.idUsuarioTomada !== null &&
                    detalleSolicitud.idUsuarioTomada !== idUsuario
                }
            >
                AUDITAR
            </Button>
            {redirect && (
                <Redirect
                    to={{
                        pathname: '/autorizaciones',
                        state:{
                            from: props[0].location.pathname,
                            fromHomeScreen: true,
                            sendGestion: true,
                            idSolicitud: detalleSolicitud.nroSolicitud,
                            idBandejaAutorizacion: detalleSolicitud.idBandejaAutorizacion
                        }       
                    }}
                />
            )}
        </>
    )
}
